import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { RequestService } from 'src/app/core/services/request/request.service';
import { Location } from '@angular/common';
declare var dataLayer;

@Component({
    selector: 'app-render-badge-action',
    templateUrl: './render-badge-action.component.html',
    styleUrls: ['./render-badge-action.component.scss'],
    standalone: false
})
export class RenderBadgeActionComponent implements OnInit {

  // value/rowData ya no se enlazan automáticamente por angular2-smart-table
  // v3.x (antes lo hacía ViewCell de ng2-smart-table); ahora se asignan
  // manualmente desde el componentInitFunction de la columna en
  // request-table.component.ts.
  @Input() value!: string | number;
  @Input() rowData!: any;
  @Output() clickEye = new EventEmitter<any>()

  /** Definimos la variable como un Observable de tipo booleano */
  public mostrarBadge$: Observable<boolean> = of(false)

  constructor(private requestService: RequestService, private cd: ChangeDetectorRef, private location: Location) { }

  ngOnInit(): void {
    this.actualizarMostrarBadge();
  }


  actualizarMostrarBadge(): void {
    
    const idFila = this.rowData?.id != null
      ? String(this.rowData.id)
      : (this.rowData?.code != null ? String(this.rowData.code) : null);

    this.mostrarBadge$ = this.requestService.devolucionesIds$.pipe(
      map(ids => {
        if (!ids || !idFila) return false;
        return ids.some(id => String(id) === idFila);
      })
    );
  }


  onViewDetails(): void {
    dataLayer.push({
      'event': 'ga_event',
      'eventName': 'click',
      'seccion': 'Listado de solicitudes',
      'page_path': this.location.path(),
      'label': 'Detalle de una solicitud',
      'link_url': `/#/detalle-solicitud/${this.rowData.id}`,
      'link_text': 'Detalle',
      'radicado': this.rowData.code,
      'estado': this.rowData.state
    })
    this.clickEye.emit(this.rowData)
  }

  onEyeClick(): void {
    this.clickEye.emit({
      action: 'view',
      data: this.rowData
    })
  }
}
